'use client';

import { UserBrowser } from '@/analytics';
import { useProductConfig } from '@/hooks/useProductConfig';
import { isClient } from '@/utils/isClient';
import { init, isInitialized } from '@fullstory/browser';
import { useEffect } from 'react';
import { FULLSTORY_ORG_ID } from '../../constants';

export default function InitializePlugins() {
  const productConfig = useProductConfig({ allowUndefinedProductConfig: true });
  useEffect(() => {
    if (!isClient()) {
      return;
    }
    const fsInitialized = isClient() ? isInitialized() : undefined;
    if (fsInitialized) {
      return;
    }
    init({
      orgId: FULLSTORY_ORG_ID,
      recordOnlyThisIFrame: isClient() ? window.self !== window.top : undefined,
      devMode: process.env.NEXT_PUBLIC_STAGE === 'dev',
      startCaptureManually: true,
    });
    const userBrowser = isClient() ? UserBrowser.get() : undefined;

    userBrowser?.updateBrowserSession(productConfig);
  });

  return null;
}
